import Micromodal from 'ember-micromodal/components/micromodal';

/**
 * This modal, built with ember-micromodal, matches the styling and behavior of
 * the legacy ember-modal-dialog implementation.
 *
 * Since ember-modal-dialog is a legacy V1 addon and blocks our migration toward
 * the Vite build system, we are removing our dependency on it.
 *
 * The LegacyModal component exists as a drop-in replacement for our previous
 * ember-modal-dialog implementation, ensuring identical functionality during
 * the transition.
 */
const LegacyModal = <template>
  <Micromodal
    id='legacy-modal'
    class='fixed left-0 top-0 z-[1000] hidden h-full w-full overflow-scroll bg-[#ffffffbf] [&.is-open]:block'
    as |OverlayElement DialogElement|
  >
    <OverlayElement
      class='relative flex h-auto min-h-[100%] w-screen items-center justify-center p-[4em_1em_3em_1em]'
      data-emd-overlay
    >
      <DialogElement
        class='ember-modal-dialog relative max-h-[100%] rounded-[8px] bg-white p-[10px] shadow-[0_0_10px_#ddd]'
      >
        {{! will be filled by in-element helper }}
      </DialogElement>
    </OverlayElement>
  </Micromodal>
</template>;

export default LegacyModal;
